import { graphql } from "gatsby";
import { SwitchesBasic, SwitchesInline } from "../../../../src/examples/components/Switches";
import * as React from 'react';
export default {
  graphql,
  SwitchesBasic,
  SwitchesInline,
  React
};